import { ApiProperty } from "@nestjs/swagger";
export class PlantsDto {
    @ApiProperty()
    plantId: number;

    @ApiProperty()
    plantCode: string;

    @ApiProperty()
    plantName: string;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    versionFlag: number;
}